// eslint-disable-next-line import/prefer-default-export
export const MODAL_ID = {
  ADULT_DEPENDANT_AGE_ERROR: 'adult-dependant-age-error',
  ADULT_DEPENDANT_SCALE_UNAVAILABLE_ERROR: 'adult-dependant-scale-unavailable-error',
  AGR: 'agr',
  COMPLEMENTARY_PRODUCT: 'complementary-product',
  COPAYMENT_SELECT: 'copayment-select',
  DECLARATION: 'declaration',
  DEMO_STANDARD: 'demo-standard',
  PREMIUM_CHANGE: 'premium-change',
  SAVER_WARNING: 'saver-warning',
  SEGMENTATION: 'segmentation',
  SERVICE_DETAILS: 'service-details',

  // Demo modals
};
